import React, { useEffect } from "react";
import {
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  SelectChangeEvent,
  FormHelperText,
} from "@mui/material";
import { useSelector } from "react-redux";
import AppState from "../../../AppState";
import { usePackageMaster } from "../../../@hooks/usePackageMaster";
import { FORM_STYLES } from "../../../constants";

interface PackageFieldProps {
  value: string;
  error: string;
  packageCodeOptions: { actualValue: string }[];
  handleChange: (event: SelectChangeEvent) => void;
  handleBlur: (
    event: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => void;
  hasError: (field: string, condition: boolean) => boolean;
  formFieldsDisabled?: boolean;
  CustomIconComponent?: React.ElementType;
}

const PackageField: React.FC<Omit<PackageFieldProps, "packageCodeOptions">> = ({
  value,
  handleChange,
  handleBlur,
  hasError,
  error,
  formFieldsDisabled = false,
  CustomIconComponent,
}) => {
  const packageCodeOptions = useSelector(
    (state: AppState) => state.packageOptionMasterData
  );
  const { loadPackageOptions } = usePackageMaster();

  useEffect(() => {
    if (!packageCodeOptions?.length) {
      loadPackageOptions();
    }
  }, [packageCodeOptions, loadPackageOptions]);

  return (
    <Grid item md={3} xs={12}>
      <FormControl fullWidth size="small">
        <InputLabel style={FORM_STYLES.LABEL} shrink={true} id="packageLabel">
          Package Type <sup>*</sup>
        </InputLabel>
        <Select
          variant="outlined"
          id="package"
          className="select"
          fullWidth
          displayEmpty
          onChange={handleChange}
          error={hasError("package", !value)}
          disabled={formFieldsDisabled}
          onBlur={handleBlur}
          name="package"
          value={value}
          style={FORM_STYLES.LABEL}
          renderValue={(selected) => {
            if (
              !selected ||
              (typeof selected === "string" && selected.length === 0)
            ) {
              return <em>Select Package Type</em>;
            }
            return selected;
          }}
          IconComponent={CustomIconComponent}
          label="Package Type"
          labelId="packageLabel"
        >
          {(packageCodeOptions ?? []).map((obj: { actualValue: string }) => (
            <MenuItem
              style={FORM_STYLES.LABEL}
              key={obj?.actualValue}
              value={obj?.actualValue}
            >
              {obj?.actualValue}
            </MenuItem>
          ))}
        </Select>
        {error && <FormHelperText error>{error}</FormHelperText>}
      </FormControl>
    </Grid>
  );
};

export default PackageField;
